import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface EmailLogStats {
  Total: number;
  InRange: number;
  Sent: number;
  Failed: number;
  Skipped: number;
}

/**
 * Outbound email audit log. Restricted server-side to global admins.
 */
@Injectable({
  providedIn: 'root'
})
export class EmailLogService {
  private http = inject(HttpClient);

  search(criteria?: any) {
    return firstValueFrom(this.http.post<{ List: any[], Total: number }>('/api/emaillog/search', criteria || {}));
  }

  stats(criteria?: any) {
    return firstValueFrom(this.http.post<EmailLogStats>('/api/emaillog/stats', criteria || {}));
  }

  previewPromoCampaign(payload: any) {
    return firstValueFrom(this.http.post<any>('/api/emaillog/promo-campaign/preview', payload || {}));
  }

  sendPromoCampaignTest(payload: any) {
    return firstValueFrom(this.http.post<any>('/api/emaillog/promo-campaign/test', payload || {}));
  }

  sendPromoCampaign(payload: any) {
    return firstValueFrom(this.http.post<any>('/api/emaillog/promo-campaign', payload || {}));
  }
}
